import { render, staticRenderFns } from "./LandingPageSliderSection.vue?vue&type=template&id=4ec8c624&scoped=true"
import script from "./LandingPageSliderSection.vue?vue&type=script&lang=js"
export * from "./LandingPageSliderSection.vue?vue&type=script&lang=js"
import style0 from "./LandingPageSliderSection.vue?vue&type=style&index=0&id=4ec8c624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8c624",
  null
  
)

export default component.exports